<template>
	<div class="search_area mb_20">
		<input
			type="text"
			v-model="searchKeyword"
			:placeholder="$t('input.placeholder.search_assets')"
		/>
		<a class="search_icon SEARCH"></a>
	</div>

	<div class="slide_area mb_20">
		<swiper
			:navigation="sliderNavigation"
			:slides-per-view="slidesPerView"
			:slides-per-group="slidesPerGroup"
			:space-between="spaceBetween"
			:modules="modules"
			:initialSlide="initialSlide"
		>
			<swiper-slide v-for="item in account_list" :key="item.seq"
				><input
					type="radio"
					:id="item.code"
					class="radio_asset"
					v-model="accountSeq"
					name="asset"
					:value="item.seq"
					@change="$emit('changeAccount', item.seq)"
				/>
				<label class="asset_box type01 box" :for="item.code">
					<span :class="[item.code, 'large']"></span>
					<span class="code mb_4">{{ item.code }}</span>
					<span class="name">{{ item.asset_title }}</span>
				</label>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Navigation } from 'swiper';
import { filter } from 'lodash';
import { isMobile } from '@/common/mobile';

export default {
	name: 'account-picker',
	emits: ['changeAccount'],
	data() {
		return {
			searchKeyword: '',
			accountSeq: null,
			modules: [Navigation],
			sliderNavigation: !isMobile(),
			slidesPerView: isMobile() ? 3.4 : 5,
			slidesPerGroup: isMobile() ? 3 : 5,
			spaceBetween: isMobile() ? 10 : 0,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		account_list() {
			return filter(this.accounts, account => {
				return (
					account.code
						.toLowerCase()
						.includes(this.searchKeyword.toLowerCase()) ||
					account.asset_title
						.toLowerCase()
						.includes(this.searchKeyword.toLowerCase())
				);
			});
		},
		initialSlide() {
			if (this.$route.query.accountSeq) {
				return this.accounts.findIndex(item => {
					return item.seq === parseInt(this.$route.query.accountSeq);
				});
			} else {
				return 0;
			}
		},
	},
	created() {
		this.accountSeq = this.$route.query.accountSeq || null;
	},
};
</script>
